export default{
    '403': '当前操作没有权限',
    '404': '访问资源不存在',
    '500': '系统异常',
    'default': '系统未知错误，请反馈给管理员'
}